import React from 'react';

interface PropType {
    label?: string;
    error?: string;
    labelWidth?: number;
}

class FormRow extends React.Component<PropType> {
    public render() {
        const labelWidth = this.props.labelWidth ? this.props.labelWidth : 2;
        const fieldWidth = 12 - (this.props.label ? labelWidth : 0);
        return (
            <div className={`form-group row ${this.props.error ? 'has-error' : ''}`}>
                {this.props.label && <label className={`col-sm-${labelWidth} col-form-label`}>{this.props.label}</label>}
                <div className={`col-sm-${fieldWidth}`}>
                    {this.props.children}
                    {this.props.error && <span className='text-danger'>{this.props.error}</span>}
                </div>
            </div>
        );
    }
}

export default FormRow;



// WEBPACK FOOTER //
// ./src/components/Form/FormRow.tsx